/*@ngInject*/
export default ['$resource','BASE_URL', function ($resource, BASE_URL){ return $resource(BASE_URL + "/instance-config/:resource", {}, {
  shouldUseDifferentCallPanel: {method: 'GET', params: {resource: 'use-different-callpanel'}},
})}];
